<!-- TABS moeten default bovenaan komen en basis project moet een implementatie zijn van subproject en mee in tabs komen-->
<!-- best om het basis projec tmoet het formulier ophalen dat nu in EditProjectComponent sttat-->
<div class="container">
  <div *ngIf="!init" style="align-self: center;">
    <mat-spinner
      style="margin: auto;"
      color="primary"
      diameter="48"
    ></mat-spinner>
  </div>
  <div *ngIf="init">
    <button
      (click)="openTab(subproject, true)"
      mat-flat-button
      class="btn-gray"
      style="margin-bottom: 10px;"
      *ngFor="let subproject of this.project.subProjects | archivefilter"
      [ngClass]="{ active: getActive(subproject) }"
      [disabled]="subproject.id == null"
    >
      {{ getTitle(subproject) }}
      <span *ngIf="subproject.showExecutedCheck">
        <mat-icon
          class="small-medium-icon translate-check"
          svgIcon="check"
        ></mat-icon>
      </span>
    </button>
    <button
      *ngIf="project.id != null"
      mat-flat-button
      [matMenuTriggerFor]="subProjectMenu"
      class="btn-gray btn-add"
      style="margin-bottom: 10px;"
    >
      <mat-icon class="add-tab-button accent">add</mat-icon>
    </button>
    <mat-menu
      class="menu menu-width"
      #subProjectMenu="matMenu"
      xPosition="after"
    >
      <button mat-menu-item (click)="addAdjustment()">
        Aanpassing
      </button>
      <button mat-menu-item (click)="addSoldRented()">
        Sticker VV
      </button>
      <button mat-menu-item (click)="addRepo()">
        Weghalen
      </button>
    </mat-menu>
    <div class="edit-project">
      <edit-view-picker
        [subproject]="activeProject"
        [project]="this.project"
        [productAdded]="productAdded"
        [boardPartAdded]="boardPartAdded"
        [standardStickerPartAdded]="standardStickerPartAdded"
        [standardStickerPartDeleted]="standardStickerPartDeleted"
        [projectContactIdAssigned]="projectContactIdAssigned"
        (save)="saveSubProject($event)"
        (deleted)="subProjectDeleted()"
      >
      </edit-view-picker>
    </div>
  </div>
</div>
<!-- code van mat component picker-->
